import InputErrorMessage from '../shared/InputErrorMessage';

export default InputErrorMessage;
